import { bd, type AdjuntoLocal } from '../almacen/db.js';
import { sha256DeBase64, base64DeDataUrl, uuid } from '../almacen/cripto.js';
import { capturarGeo } from '../almacen/red.js';

/**
 * "Cámara in-app" (HU-09). En la app nativa la foto se toma con CameraX /
 * AVFoundation hacia el sandbox cifrado, NUNCA desde la galería. En este
 * prototipo web generamos una captura sintética (un documento con timestamp y
 * GPS estampados) para demostrar fielmente el resto de la cadena: hash SHA-256
 * calculado AL CAPTURAR, metadatos embebidos y almacenamiento local fuera de
 * cualquier galería pública. El hash lo revalida el servidor al subir.
 */
export async function capturarFoto(
  tipo: AdjuntoLocal['tipo'],
): Promise<AdjuntoLocal> {
  const geo = await capturarGeo();
  const dataUrl = generarImagen(tipo, geo);
  const base64 = base64DeDataUrl(dataUrl);
  const hashSha256 = await sha256DeBase64(base64);
  const id = uuid();
  const adjunto: AdjuntoLocal = {
    id,
    tipo,
    dataUrl,
    hashSha256,
    mime: 'image/png',
    capturadaEn: new Date().toISOString(),
    geo: { lat: geo.lat, lng: geo.lng, precisionMetros: geo.precisionMetros, esSimulada: geo.esSimulada },
  };
  await bd.adjuntos.put(adjunto);
  return adjunto;
}

const TITULO: Record<AdjuntoLocal['tipo'], string> = {
  CONSTANCIA_PAPEL_FOTO: 'Constancia en papel',
  FACHADA_FOTO: 'Fachada / timbre',
  EVIDENCIA_FOTO: 'Evidencia',
};

function generarImagen(tipo: AdjuntoLocal['tipo'], geo: { lat: number; lng: number }): string {
  const canvas = document.createElement('canvas');
  canvas.width = 600;
  canvas.height = 800;
  const ctx = canvas.getContext('2d')!;
  ctx.fillStyle = '#eceae3';
  ctx.fillRect(0, 0, 600, 800);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(40, 60, 520, 680);
  ctx.fillStyle = '#0f6e56';
  ctx.fillRect(40, 60, 520, 10);
  ctx.fillStyle = '#1a1a18';
  ctx.font = 'bold 26px sans-serif';
  ctx.fillText(TITULO[tipo], 70, 130);
  ctx.font = '16px sans-serif';
  ctx.fillStyle = '#5b5b57';
  const lineas = [
    'Captura in-app (cámara, sin galería)',
    `Fecha/hora: ${new Date().toLocaleString('es-AR')}`,
    `GPS: ${geo.lat.toFixed(5)}, ${geo.lng.toFixed(5)}`,
    'Hash SHA-256 calculado al capturar',
  ];
  lineas.forEach((l, i) => ctx.fillText(l, 70, 180 + i * 30));
  // unas "líneas manuscritas" para simular el documento firmado
  ctx.strokeStyle = '#c9c7c0';
  for (let i = 0; i < 9; i++) {
    ctx.beginPath();
    ctx.moveTo(70, 340 + i * 42);
    ctx.lineTo(530, 340 + i * 42);
    ctx.stroke();
  }
  // un ruido leve para que cada captura tenga hash distinto
  ctx.fillStyle = 'rgba(0,0,0,0.02)';
  ctx.fillRect(Math.random() * 500, 700 + Math.random() * 60, 40, 4);
  return canvas.toDataURL('image/png');
}
